import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PelouseService {
  private API_URL = environment.apiUrl;

  constructor(
      private http: HttpClient,
  ) { }
  // tslint:disable-next-line:typedef
  getAllImputesArrivees() {
    return this.http.get<any>(`${this.API_URL}/secretaire/CourrierArriveeImputesPelouse`) ;
  }
  // tslint:disable-next-line:typedef
  getAllImputesDepart() {
    return this.http.get<any>(`${this.API_URL}/secretaire/CourrierDepartImputesPelouse`) ;
  }
}
